import Switch from "./switch.component.js";

export default angular
    .module("oui.switch", [])
    .component("ouiSwitch", Switch)
    .name;
